import { createFileRoute } from '@tanstack/react-router'
import { DropshipDraftVersionedPage } from '@/pages/dropship-draft-progress-v2'

export const Route = createFileRoute('/_authenticated/projects/dropship-drafts/$draftUuid')({
  staticData: { title: 'Quote Draft' },
  component: DropshipDraftRoute,
})

function DropshipDraftRoute() {
  const { draftUuid } = Route.useParams()
  return <DropshipDraftVersionedPage draftUuid={draftUuid} />
}
